import LandingTextField from './LandingTextField';

export default LandingTextField;
